export default __webpack_public_path__ + "static/media/lyre.e7159fe6.svg";